(function() {
  'use strict';
    
  angular
    .module('app.dialogs')
    .controller('MarsConfirmController', MarsConfirmController);
      
    MarsConfirmController.$inject = [
    '$log',
    '$mdDialog',
    'locals'
  ];
    
  function MarsConfirmController($log, $mdDialog, locals) {
    $log = $log.getInstance('MarsConfirmController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.cancel = cancel;
    vm.cancelText = locals.cancel || 'Cancel';
    vm.content = locals.content;
    vm.htmlContent = locals.htmlContent;
    vm.ok = ok;
    vm.okText = locals.ok || 'OK';
    vm.title = locals.title;
    
    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      $mdDialog.hide();
    }

  }
  
})();